<template>
<v-row>
  <v-col md="9">
    <div id="mapa" class="mx-1 my-1" style="min-width:100%; min-height:100%;"></div>
    <v-btn
      class="position-absolute pos-right pos-top mt-4 mr-12 px-0"
      color="secondary"
      text
      x-small
      icon
      @click="centerMap"
    >
      <v-icon small>mdi-home</v-icon>
    </v-btn>
    <v-btn
      class="position-absolute pos-right pos-top mt-4 mr-7 px-0"
      color="secondary"
      text
      x-small
      icon
      @click="zoomOut"
    >
      <v-icon small>mdi-magnify-minus</v-icon>
    </v-btn>
    <v-btn
      class="position-absolute pos-right pos-top mt-4 mr-2 px-0"
      color="secondary"
      text
      x-small
      icon
      @click="zoomIn"
    >
      <v-icon small>mdi-magnify-plus</v-icon>
    </v-btn>
  </v-col>
  <v-col md="3" id="mapa-data">
    <div style="max-height: 290px" class="overflow-y-auto">
      <ul>
        <li v-for="(d,i) in geo_data_tweets" :key="'li-'+i">{{d.city+": "+d.quantity}}</li>
      </ul>
    </div>
  </v-col>
</v-row>
</template>

<script>
import * as d3 from "d3";
import extractService from "@/api/modules/extract";
import * as topojson from "topojson";

var topo, projection, path, filtered_data, tooltip,zDom, width, height, zoom;
var scale=1;
var svg, g;
var x,y;
export default {
  name: "MapChart",
  props: {
    process_id: {
      required: true
    }
  },
  data() {
    return {
      geo_data_tweets: []
    };
  },
  mounted() {
    this.generateMap();
  },
  methods: {
    generateMap() {
      zoom = d3.zoom()
        .scaleExtent([1, 16])
        .on("zoom", zoomed);

      width = document.getElementById('mapa').offsetWidth;
      height = width/2;

      svg = d3.select('#mapa').append('svg')
        .attr("viewBox", [0, 0, width, height])
        .on("click", clicked);

      g = svg.append("g");

      function setup(width, height) {
        projection = d3.geoMercator()
          .translate([(width / 2), (height * 3 / 5)])
          .scale(width / 3 / Math.PI);

        path = d3.geoPath().projection(projection);
      }

      function draw(topo) {

        svg.append("path")
          .attr("d", path);


        g.append("path")
          .datum({
            type: "LineString",
            coordinates: [
              [-180, 0],
              [-90, 0],
              [0, 0],
              [90, 0],
              [180, 0]
            ]
          })
          .attr("class", "equator")
          .attr("d", path);


        var country = g.selectAll(".country").data(topo);

        country.enter().insert("path")
          .attr("class", "country")
          .attr("d", path)
          .attr("id", function(d) {
            return d.id;
          })
          .attr("title", function(d) {
            return d.properties.name;
          })
          .style("fill", '#96b6b6');
      }

      function draw_points(){
        d3.select('#mapa>div.tooltip').remove();
        tooltip = d3.select("#mapa")
          .append("div")
          .style("opacity", 0)
          .attr("class", "tooltip")
          .style("background-color", "black")
          .style("border-radius", "5px")
          .style("padding", "10px")
          .style("color", "white")
        var radius = d3.scaleSqrt()
          .domain([.2, zDom])
          .range([.2, 8]);

        var showTooltip = function(d) {
          tooltip
            .transition()
            .duration(200)
          tooltip
            .style("opacity", 1)
            .html(d.originalTarget.__data__.city + " : " + d.originalTarget.__data__.quantity + " tweets")
            .style("top", (d.layerY - 20) + "px")
            .style("left", (d.layerX) + "px")
        }
        var moveTooltip = function(d) {
          tooltip
            .style("top", (d.layerY - 20) + "px")
            .style("left", (d.layerX) + "px")
        }
        var hideTooltip = function() {
          tooltip
            .transition()
            .duration(200)
            .style("opacity", 0)
        }

        d3.selectAll('.bubble-map').remove();
        g
          .selectAll("myCircles")
          .data(filtered_data)
          .enter()
          .append("circle")
          .attr("cy", function(d) {
            return projection([d.geo.lng, d.geo.lat])[1]
          })
          .attr("cx", function(d) {
            return projection([d.geo.lng, d.geo.lat])[0]
          })
          .attr("r", function(d) {
            return radius(d.quantity/scale)
          })
          .attr("class", "bubble-map")
          .style("fill", "69b3a2")
          .attr("fill-opacity", .5)
          .on("mouseover", showTooltip)
          .on("mousemove", moveTooltip)
          .on("mouseleave", hideTooltip)

        svg.call(zoom);
      }

      //geo translation on mouse click in map
      function clicked(d) {
        projection.invert([d.layerX, d.layerY]);
      }

      function zoomed(d) {
       g.attr("transform", d.transform)
       scale=d.transform.k
       console.log("scale");
       console.log(scale);
       draw_points()
     }

     function centerMap() {
        var max=filtered_data[0]
        filtered_data.forEach((i)=>{
          if (i.quantity>max.quantity) {
            max=i
          }
        })
        x = projection([max.geo.lng, max.geo.lat])[0]
        y = projection([max.geo.lng, max.geo.lat])[1]
        svg.transition().duration(1500).call(
          zoom.transform,
          d3.zoomIdentity.translate(width / 2, height / 2).scale(8).translate(-x, -y)
        );
     }
      extractService.getWorldData()
        .then((world) => {
          setup(width, height);
          var countries = topojson.feature(world, world.objects.countries).features;
          topo = countries;
          draw(topo);
          extractService.getOrigenesByCity(this.process_id)
            .then((res) => {
              zDom = 0
              filtered_data = []
              Object.keys(res.data).forEach(city => {
                if (res.data[city].quantity > zDom) {
                  zDom = res.data[city].quantity
                }
                filtered_data = filtered_data.concat({
                  'city': city,
                  'geo': res.data[city].geo,
                  'quantity': res.data[city].quantity
                })
              });
              this.geo_data_tweets = filtered_data.sort((a, b) => {
                  return b.quantity - a.quantity;
              });
              draw_points()
              centerMap()
            })
        })
    },
    centerMap(){
      svg.transition().duration(1500).call(
        zoom.transform,
        d3.zoomIdentity.translate(width / 2, height / 2).scale(8).translate(-x, -y)
      );
    },
    zoomIn(){
      svg.transition().duration(1000).call(zoom.scaleBy, 2)
    },
    zoomOut(){
      svg.transition().duration(1000).call(zoom.scaleBy, 0.5)
    }
  }
};
</script>

<style>
div.tooltip {
  position: absolute;
  text-align: center;
  padding: 2px;
  font: 12px sans-serif;
  background: lightsteelblue;
  border: 0px;
  border-radius: 8px;
  pointer-events: none;
}
</style>
